<app-container class="shadow-md my-6 mx-auto copy max-w-3xl">
	<header class="page-header">
		<h2>Terms of use</h2>
	</header>

	<p>
		This agreement (the “Agreement”) is a legal agreement between you, either an
		individual or a single legal entity (“You” or “you”), and LawLabs Inc.
		(“LawLabs”). This Agreement governs your use of LawLabs’ Products, Software
		or Services, including any updates and accompanying written documentation
		provided to you (the “Products, Software or Services”).
	</p>

	<p>
		You acknowledge and agree that LawLabs may occasionally contact you via
		email. Please see the LawLabs Privacy Policy, which is incorporated into
		this Agreement by reference.
	</p>

	<h3 class="my-4">1. Rights Granted & Permitted Use</h3>

	<p>
		LawLabs grants to you, for use in connection with your internal business
		operations, a limited, non-exclusive, non-transferable, license to the
		Software and Documentation, subject to the Permitted Use and the terms set
		forth in this Agreement. Your rights to use the Software and Documentation
		are subject to the ongoing payment of applicable per-file transaction fees.
		Updates (provided pursuant to Section 6 (License & Updates)) will form part
		of the Software and will be subject to rights granted in this Agreement. You
		may permit your employees, agents and contractors to use the Software for
		purposes permitted pursuant to this Agreement and you will be responsible
		for their compliance in accordance with the terms of this Agreement. All
		rights not expressly granted to you hereunder are reserved by LawLabs. You
		acknowledge that the Software may require activation by way of an activation
		key on initial installation and from time to time based on certain events,
		including, without limitation, Updates and changes to hardware on which the
		Software is installed. You acknowledge that the activation keys and internal
		controls in the Software do not necessarily restrict usage to the Permitted
		Use and do not necessarily ensure compliance with this Agreement.
	</p>

	<h3 class="my-4">2. License Restrictions</h3>

	<p>
		You agree (a) subject to any non-waivable rights you may enjoy under
		applicable law, not to decompile, disassemble, reverse engineer, or
		otherwise attempt to derive the Software’s source code from the object code;
		(b) not to modify, enhance, change the data structures for or create
		derivative works from, the Software, (c) not to rent, lease, sell,
		sublicense or otherwise transfer the Software to third parties; (d) not to
		make the Software available in any form to any person other than your
		employees, agents and contractors whose job performance requires such
		access; and (e) to use reasonable care and protection to prevent the
		unauthorized use, copying, publication or dissemination of the Software. You
		shall not allow access to the Software by any service bureau, third party
		outsourcer, or other similar third party service provider unless LawLabs
		consents to such access in writing.
	</p>

	<h3 class="my-4">3. Ownership of Intellectual Property; Your Input</h3>

	<p>
		As between LawLabs and you, LawLabs retains all title, ownership, and
		intellectual property rights in and to the Software and Documentation, and
		all developments by LawLabs in connection with this Agreement. You
		acknowledge and agree that you are only licensing the right to use LawLabs’
		Software and Documentation and that no sale or other transfer of any title
		or ownership or any proprietary interest of any kind to such Software or
		Documentation is contemplated hereunder, other than the sale of the limited
		licenses as expressly granted herein. Except as specified in Section 1
		(Rights Granted & Permitted Use) or as expressly authorized in writing by
		LawLabs and, subject to any non-waivable rights you may enjoy under
		applicable law, you shall not allow for any duplicates or reproduction of
		the Software to be made.
	</p>

	<p>
		LawLabs shall have a royalty-free, worldwide, transferable, sub-licensable,
		irrevocable, perpetual license to use or incorporate into the Software any
		Input made by you. LawLabs shall have no obligation to make any Input an
		Update. You shall have no obligation to provide any Input.
	</p>

	<p>
		Lawlabs acknowledges that any data entered into the Software by you (the
		“Data”) is owned by you. During your active use of the Software or within 30
		days thereafter, you may request an export of your data. Upon request,
		Lawlabs agrees to make reasonable efforts to export said Data into a
		commercially acceptable format such that you may use such Data in a
		different Program or manner. After this export period, LawLabs may delete
		your Data in accordance with its standard schedule and procedures. If you
		elect to proactively delete your account at any time, your Data will be
		deleted permanently and cannot be retrieved.
	</p>

	<p>
		Lawlabs further confirms that all data shall be encrypted upon its
		submission by you, and shall not be made available to any other User of the
		Software, or to any third party or employee of Lawlabs without your prior
		written permission. Lawlabs shall have the right to access, amend, or
		otherwise change the settings/users found in your Admin section, but shall
		not have any further rights with regards to any other Data.
	</p>

	<h3 class="my-4">4. Use of Logo for Promotional & Marketing Materials</h3>

	<p>
		You provide LawLabs with permission to use your trademark, logo and trade
		name (“Branding”) within LawLabs’ promotional and marketing materials.
		LawLabs is granted no other right to the Branding and acknowledges that it
		shall not gain any proprietary interest in the same. LawLabs is under no
		obligation to make use of, or to provide compensation for, the right or
		permission granted by you to the Branding. LawLabs shall be the exclusive
		owner of all right, title, and interest, including copyright in its
		promotional and marketing materials. The permission to use the Branding may
		be terminated at any time by you by providing written notice to LawLabs.
		Upon such termination, LawLabs shall refrain from future use of the
		Branding; however, LawLabs may continue to distribute and use the
		promotional and marketing materials where your Branding has been previously
		printed prior to the notice of termination and where such placements cannot
		be discontinued or altered without LawLabs incurring a penalty.
	</p>

	<h3 class="my-4">5. Your Responsibilities</h3>

	<p>
		You shall enter all data required for implementation of the Software and
		shall be responsible for the integrity of such data. LawLabs shall not have
		any liability for any of your data, including for data that LawLabs
		personnel may enter in an effort to assist you or any errors made in such
		efforts to assist you.
	</p>

	<p>
		You shall assume full responsibility for (i) the content of any database,
		(ii) the selection and implementation of controls on its access and use of
		the Software and (iii) configuration data associated with the implementation
		of the Software.
	</p>

	<h3 class="my-4">6. License & Updates</h3>

	<p>
		In consideration of the Fees being paid by you in accordance with the terms
		of this Agreement, LawLabs will provide to you in a timely manner and
		without additional charge:
	</p>

	<ol type="a">
		<li>
			The right to “use” under license, as provided in Section 1 (Rights Granted
			& Permitted Use), the Software, Documentation, and related materials;
		</li>
		<li>
			Commercially reasonable efforts to correct any Errors reported to it by
			you, provided such Errors relate to the proper functioning of the Software
			and have not been caused by negligence on the part of you, a computer
			malfunction, Third Party Materials or another causes external to the
			Software, and further provided that you acknowledge and agree that not all
			Errors are capable of being corrected; and
		</li>
		<li>
			Updates to the Software that LawLabs makes generally available to its
			Customers, and Documentation as reasonably necessary for the proper
			function and continued material conformity of the Software with the
			applicable Documentation. Any programs which provides new functionality or
			expand the function of the Software and are regarded as New Products by
			LawLabs, and for which LawLabs separately charges other customers, are not
			covered by this Agreement, but may be offered to you for license on terms
			consistent with this Agreement.
		</li>
	</ol>

	<h3 class="my-4">7. Interfaces</h3>

	<p>
		Software interfaces to third party vendor systems may be available, as
		indicated in the Documentation. To the extent such third party vendor system
		interfaces are available, LawLabs shall only provide access to the third
		party system via the Software and shall not be responsible for any
		interactions between you and the third party vendor system. You shall act as
		a liaison between LawLabs and any third party vendor(s) with which the
		Software shall interface. Transactions processed by a third party vendor
		system may be subject to separate licensing requirements. You acknowledge
		and agree that you have the sole obligation to obtain, or cause your third
		party vendor to obtain, any and all such licenses.
	</p>

	<h3 class="my-4">8. Global Databases</h3>

	<ol type="a">
		<li>
			The Software provides access to various Global Databases, which are
			populated with Contact Information which are provided by Users of the
			Software. You have the ability and obligation to maintain your current and
			correct Contact Information through the Software. If LawLabs determines
			any Contact Information to be inaccurate, LawLabs reserves the right to
			update and correct such Contact Information. You must only include
			publically available business contact information in the Contact
			Information added into any Global Database and represent and warrant that
			you shall not provide any information to the Global Database that is not
			business contact information, including but not limited to any personally
			identifiable information.
		</li>
		<li>
			You agree that if you provide any Contact Information to the Software, you
			represent and agree that you have the right to do so. By providing the
			Contact Information you confirm that you provide LawLabs with permission
			to make such Contact Information publicly available to other users of the
			Software.
		</li>
		<li>
			You may only use the Contact Information from Global Databases solely for
			the purposes of populating forms, fields and documents within the
			Software, corresponding with other Parties whose information is found in
			the Global Databases, transactions conducted using the Software, and
			exercising your rights and obligations under these Terms of Use and for no
			other purpose. You shall not use the Contact Information for the purpose
			of sending any marketing or advertising materials or any “Commercial
			Electronic Messages” as defined in Canadian Anti Spam Legislation.
		</li>
	</ol>

	<h3 class="my-4">9. Payment Terms</h3>

	<p>You agree to pay LawLabs all Fees as set in the sections below.</p>

	<ol type="a">
		<li>
			You are responsible for the payment of corresponding File Transaction Fee
			charged in the course of opening new files in the Software, including, but
			not limited to, those denoted as purchase, sale and mortgages
			transactions. Such Fees are subject to change from time to time at LawLabs
			discretion, with at least 60 (sixty) days’ notice of any pending change is
			provided to you. If your account has been activated on or before June 30,
			2022, such Fees cannot be changed for at least 2 (two) years from the date
			that you activated the Software.
		</li>
		<li>
			Additional fees may apply in order to access third party products and
			services offered by way of the File Transaction Fee referenced in section
			(a) above. These additional fees are subject to change from time to time
			at the discretion of the applicable third party provider. Lawlabs shall
			not charge an additional fee for access to these third party providers
			other than as set out in section (a) above.
		</li>
		<li>
			You will only use each file or record in relation to the single
			transaction or entity for which it was originally purchased. You are
			required to create a new Transaction for each purchase, sale, or mortgage
			transaction processed using the Software. Non-compliance with this section
			may result in suspension and/or termination of your access to the
			Software.
		</li>
		<li>
			You may pay for Fees in advance, by preloading your Software account using
			your credit card, or weekly in arrears. Where payment is made weekly in
			arrears, you will receive an invoice from LawLabs at the end of the
			applicable weekly payment period. You agree to pay applicable Fees within
			30 days from the date of invoice. With regard to any undisputed invoiced
			amount that is not paid when due, LawLabs reserves the right to charge,
			and you agree to pay, a late payment fee on the unpaid balance from the
			due date until paid (whether before or after judgment) equal to one and
			one half percent (1.5%) per month, which is eighteen percent (18%) per
			annum. If it is determined that LawLabs properly charged any amount
			disputed and withheld by you, the late fee will be assessed and paid on
			the disputed, withheld amount.
		</li>
	</ol>

	<p>
		You acknowledge that LawLabs reserves the right to suspend or interrupt your
		use of the Software for any period during which any Fees due in accordance
		with the terms of this Agreement remain unpaid for seven (7) days after
		LawLabs provides advanced written notice (including by way of email) of such
		unpaid Fees to you. In such an event, LawLabs shall not be precluded from
		exercising any additional remedies that might be available to under the
		terms of this Agreement or otherwise.
	</p>

	<h3 class="my-4">10. Confidentiality</h3>

	<p>
		By virtue of this Agreement, the parties may have access to the other
		party’s Confidential Information. The parties will hold each other’s
		Confidential Information in confidence. With respect to all Confidential
		Information other than Software and Educational Material provided by
		LawLabs, such obligation shall terminate three (3) years after termination
		of this Agreement. With respect to the Software and Educational Material
		provided by LawLabs, such obligation is perpetual. The parties will not make
		each other’s Confidential Information available in any form to any
		third-party for any purpose except to the extent necessary to exercise its
		rights under this Agreement and will treat Confidential Information of the
		other party with the same degree of care with which it would treat its own
		confidential information of a like nature, and in no case less than a
		reasonable degree of care. The parties agree that the limitations of
		liability contained herein shall not apply to any disclosure of Software or
		Educational Material in breach of this provision and that any such breach
		shall terminate the rights to such Software and Educational Material to you
		under this Agreement. Confidential Information may only be disclosed to
		those employees or agents who are required to access it in furtherance of
		this Agreement and who are required to protect such Confidential Information
		against unauthorized disclosure. Both parties shall each implement and
		enforce policies and contractual obligations with its employees, agents and
		subcontractors to ensure its employees, agents and subcontractors protect
		the Confidential Information as required pursuant to this Section 10. It
		shall not be a breach of this Section 10 if Confidential Information is
		disclosed pursuant to subpoena or other compulsory judicial or
		administrative process, provided that the party served with such process
		promptly notifies, to the extent legally permissible, the other party and
		provides reasonable assistance so that the other party may seek, at its own
		cost and expense, a protective order against public disclosure. The parties
		recognize and agree that monetary damages are an inadequate remedy for
		breach of the obligations set forth in this Section 10 and further recognize
		that any breach would result in irreparable harm to the non-breaching party.
		In the event of such a breach, the non-breaching party may seek injunctive
		relief from a court of competent jurisdiction to pursue those remedies
		available to it.
	</p>

	<h3 class="my-4">11. Indemnification</h3>

	<p>
		LawLabs will indemnify, defend and hold you harmless from, at its expense,
		any action brought against you by a third party based upon a claim that your
		use of the Software within the scope of these Terms and Conditions infringes
		a United States, Canadian, United Kingdom, European Union, Australian or New
		Zealand patent or copyright issued to or held by a third party, or
		misappropriates a trade secret of such third party; provided that you notify
		LawLabs promptly in writing of such claim, provide LawLabs with the sole
		control and authority to defend or settle such action or claim, and give
		LawLabs the authority, information and assistance necessary to settle or
		defend such claim.
	</p>

	<p>
		In the event a claim of infringement is made, or LawLabs believes that such
		a claim is likely to be made, then LawLabs shall at its expense: (a) procure
		the right for you to continue using the Software; (b) replace or modify the
		Software so that it becomes noninfringing, without materially decreasing the
		functionality of the Software; or (c) if neither (a) or (b) above is
		commercially practical, then at LawLabs’ sole option, terminate this
		Agreement upon three (3) months written notice, and either issue to you a
		credit equal to, or promptly refund to you, all File Transaction Fees paid
		by you, less an appropriately prorated amount for use, reflecting the number
		of months during which you enjoyed uninterrupted use of the Software.
	</p>

	<p>
		Notwithstanding the foregoing, LawLabs shall have no obligation to defend
		you or to pay any costs or legal fees for any action, claim or settlement,
		based upon: (a) combination, operation, integration or interfacing of the
		Software with Third Party Materials, other than Third Party Materials or
		Third Party Software with which the Software was intended to operate as
		specified in the Documentation associated with the Software if such claim
		would not have arisen but for such combination, operation, integration or
		interfacing (regardless of whether or not LawLabs has advised you that such
		use would likely result in a claim of infringement by a third party); (b)
		use of the Software in a manner other than as authorized by the
		Documentation or these Terms and Conditions; (c) modifications to the
		Software by any person other than LawLabs or its authorized agents or
		subcontractors; or (d) your failure to accept any procured right to continue
		using the Software. THE FOREGOING STATES LAWLABS’ SOLE AND EXCLUSIVE
		LIABILITY AND YOUR SOLE AND EXCLUSIVE REMEDY WITH RESPECT TO ANY CLAIM OF
		INFRINGEMENT OR MISAPPROPRIATION OF INTELLECTUAL PROPERTY RIGHTS OR
		PROPRIETARY RIGHTS OF ANY THIRD PARTY. You shall defend, indemnify and hold
		harmless LawLabs Indemnified Parties from and against any and all third
		party claims, actions, causes of action, liabilities, damages, costs and
		expenses, including reasonable legal fees, arising from or related to the
		exclusions (a) through (d) set out in the third paragraph of this Section
		11.
	</p>

	<h3 class="my-4">12. Warranties; Disclaimer of Warranties</h3>

	<ol type="a">
		<li>
			Each party represents and warrants that it shall comply with all laws
			applicable to it pertaining to its performance of its obligations under
			these Terms of Use.
		</li>

		<li>
			Except for the express warranties provided above, LawLabs make no
			warranties with respect to the Software, associated accounts, Materials,
			Support Services or any other products or services provided pursuant to
			these Terms of Use. The Software, associated accounts, Materials, Support
			Services and any other products or services are provided “as is” and “with
			all faults'', and LawLabs disclaims all other warranties, representations,
			guarantees or conditions, express or implied, including the implied
			warranty and condition of merchantability, satisfactory quality, fitness
			for a particular purpose or the use of reasonable skill and care. Without
			limiting the generality of the foregoing, LawLabs makes no express or
			implied warranties, representations, guarantees of conditions of
			merchantability, fitness for a particular purposes, the use of reasonable
			skill and care, non-infringement, satisfactory quality, accuracy, freedom
			from error or that the Software, third party software or support will meet
			all of your requirements. LawLabs makes no express or implied warranties,
			representations, guarantees or conditions with respect to any third party
			software or third party services provided with or as part of the Software
			or related services.
		</li>
	</ol>

	<h3 class="my-4">13. Limitation of Liability</h3>

	<p>
		EXCEPT FOR LIABILITY ARISING (i) FROM YOUR BREACH OF SECTION 2 (LICENSE
		RESTRICTIONS) AND ANY DISCLOSURE BY YOU OF SOFTWARE OR DOCUMENTATION IN
		BREACH OF SECTION 10 (CONFIDENTIALITY), (ii) UNDER SECTION 11
		(INDEMNIFICATION) OR (iii) FOR PERSONAL INJURY, DEATH, FRAUD OR FRAUDULENT
		MISREPRESENTATION: (A) LAWLABS’ ENTIRE LIABILITY UNDER THIS AGREEMENT OR IN
		ANY WAY RELATED TO THE SOFTWARE, THE THIRD PARTY SOFTWARE, OR ANY RELATED
		SERVICES WILL BE LIMITED TO DIRECT DAMAGES IN AN AMOUNT EQUAL TO THE FEES
		PAID BY YOU TO LAWLABS PURSUANT TO THIS AGREEMENT DURING THE TWELVE (12)
		MONTH PERIOD IMMEDIATELY PRECEDING THE FIRST EVENT GIVING RISE TO THE CLAIM;
		AND (B) NEITHER PARTY WILL BE LIABLE FOR: (i) ANY SPECIAL, PUNITIVE,
		INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES ARISING FROM OR RELATED TO
		THIS AGREEMENT OR IN ANY WAY RELATED TO THE SOFTWARE, THE THIRD PARTY
		SOFTWARE, THE HARDWARE OR ANY RELATED SERVICES; OR (ii) ANY LOSS OF REVENUE,
		PROFITS, GOODWILL OR DATA, OR DATA USE (INCLUDING AS A RESULT OF A VIRUS),
		BUSINESS INTERRUPTION, FAILURE TO REALIZE AN EXPECTED SAVING, CORRUPTION OF
		DATA, OR CLAIMS AGAINST THEM BY ANY THIRD PARTY, EVEN IF THE PARTIES ARE
		ADVISED, OR MAY REASONABLY SUPPOSED TO HAVE BEEN AWARE, OF THE POSSIBILITY
		OF SUCH DAMAGES IN ADVANCE. SUCH LIMITATIONS WILL APPLY REGARDLESS OF HOW
		THE CLAIM ARISES, WHETHER ARISING BASED ON CONTRACT, TORT, NEGLIGENCE, OR
		OTHERWISE AND WILL APPLY TO ALL SCHEDULES, ADDENDA, AGREEMENTS AND
		ATTACHMENTS RELATED TO THIS TERMS OF USE. THE FOREGOING LIMITATIONS OF
		LIABILITY ALLOCATE THE RISKS BETWEEN YOU AND LAWLABS AND FORM A MATERIAL
		BASIS OF THE BARGAIN BETWEEN THE PARTIES. LAWLABS’ PRICING REFLECTS THIS
		ALLOCATION OF RISK AND THE LIMITATION OF LIABILITY SPECIFIED HEREIN.
	</p>

	<h3 class="my-4">14. Term and Termination</h3>

	<ol type="a">
		<li>
			Term. These Terms of Use shall remain in full force and effect until
			terminated in accordance with Section 14(a) through (d).
		</li>
		<li>
			Termination for Convenience. Either party may terminate this agreement by
			giving the other party at least fourteen (14) days’ notice (the
			“Termination Notice”).
		</li>
		<li>
			Failure to Pay File Transaction Fees. In the event that you fail to pay
			the applicable File Transaction Fees when due, LawLabs reserves the right
			to elect to take one of the following courses of action (without limiting
			LawLabs’ other available remedies): (i) notify you that this Agreement
			will immediately expire (or has expired); or (ii) allow this Agreement to
			continue, in which event, the applicable File Transaction Fees for
			subsequent transactions will continue to be payable; provided, however,
			that if LawLabs does not affirmatively notify you that alternative (i) or
			(ii) has been selected, then alternative (ii) will apply.
		</li>
		<li>
			Termination by LawLabs. Subject to Section (c) (Failure to Pay File
			Transaction Fees), LawLabs has the right to terminate the license granted
			under this Agreement if you are in default of any term or condition of
			this Agreement, and fails to cure such default within thirty (30) days
			after receipt of written notice of such default. Without limitation, it
			will be deemed a default under this Agreement if you fail to pay any
			amount when due hereunder. LawLabs may terminate this Agreement
			immediately if: (i) you breach Section 2 (License Restrictions); or (ii)
			if you become insolvent, a receiver, administrator, controller or a
			liquidator is appointed to you, you assign any of its property for the
			benefit of creditors or any class of them or any proceedings have been
			commenced by or against you under any bankruptcy, insolvency or similar
			laws.
		</li>
		<li>
			Termination by You. You have the right to terminate this Agreement as set
			out in section (b).
		</li>
		<li>
			Effect of Termination. Upon termination of this Agreement for any reason,
			any and all amounts owed to LawLabs pursuant to this Agreement will be
			immediately due and payable, and all license rights granted to you
			hereunder will be immediately revoked and terminated. Following the
			termination of this Agreement, the Sections titled “Ownership of
			Intellectual Property; Your Input,” “Payment Terms,” “Confidentiality,”
			“Indemnification,” “Warranties; Disclaimer of Warranties,” “Limitation of
			Liability,” “Audit,” “Governing Law” and “General” will continue in full
			force and effect in accordance with their terms. As soon as possible after
			Termination, you will cease using and will remove all copies of the
			Software, Educational Material and any applicable copies thereof in
			accordance with Section 3 (Ownership of Intellectual Property; Your Input;
			Data) and confirm the same to LawLabs in writing by a duly authorized
			officer.
		</li>
	</ol>

	<h3 class="my-4">15. Audit</h3>

	<p>
		During active use of the Software, you shall maintain complete and accurate
		books, records, policies, and procedures (collectively “Books and Records”)
		sufficient to confirm your compliance with these Terms and Conditions and
		the Order Form(s), including without limitation compliance with Permitted
		Use, and payment of Fees to Lawlabs. During your active use of the Software
		and for a period of one (1) year thereafter, you shall permit Lawlabs (or an
		independent representative engaged by Lawlabs), upon thirty (30) days prior
		written notice, to audit (each an “Audit”) your Books and Records and
		deployment of the Software to the extent reasonably necessary to verify your
		compliance with the terms, conditions, and restrictions of this Agreement,
		at such times during your regular business hours as LawLabs may reasonably
		request. Lawlabs may exercise its right to audit no more frequently than one
		(1) time each calendar year. If any Audit should disclose any underpayment
		of Fees, you shall promptly pay Lawlabs such underpaid amount (whether
		before or after judgment), together with interest thereon at a rate of one
		and one-half percent (1.5%) per month during which each such amount was owed
		and unpaid. If the amount of such underpayment exceeds five percent (5%) of
		amounts otherwise payable, then you shall reimburse Lawlabs for Lawlabs’
		reasonable and customary audit expenses. The rights and obligations set
		forth in this Section 15 shall survive termination or expiration of your
		active use of the Software for a period of one (1) year from such
		termination or expiration.
	</p>

	<h3 class="my-4">15. Governing Law</h3>

	<p>
		This Agreement is governed by the laws of the Province of Ontario and the
		Country of Canada without regard to conflicts of laws provisions and without
		regard to the United Nations Convention on the International Sale of Goods.
		The jurisdiction and venue for actions related to this Agreement will be the
		provincial courts located in Ontario and both parties submit to the personal
		jurisdiction of those courts.
	</p>
</app-container>
